const ICON_VIEW = ({ color = "#000", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="none"
    {...props}
  >
    <path
      className="path_svg"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M24.238 9.756c-3.765.388-7.38 2.003-10.482 4.68-3.102 2.676-5.579 6.32-7.181 10.564 1.602 4.244 4.08 7.888 7.18 10.565 3.102 2.676 6.718 4.29 10.483 4.68 4.03-.053 7.965-1.51 11.358-4.206 3.393-2.695 6.106-6.521 7.83-11.039-1.724-4.518-4.437-8.344-7.83-11.04-3.393-2.695-7.329-4.152-11.358-4.204z"
    />
    <circle
      className="path_svg"
      cx={25}
      cy={25}
      r={7.11}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinejoin="bevel"
    />
  </svg>
);

export default ICON_VIEW;
